"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductTitle = function ProductTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smDown: true
  }, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: "title-divider",
    orientation: "vertical",
    flexItem: true
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    mr: "auto"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h5"
  }, children)));
};

var _default = ProductTitle;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hlYWRlci9Qcm9kdWN0SGVhZGVyL1Byb2R1Y3RUaXRsZS50c3giXSwibmFtZXMiOlsiUHJvZHVjdFRpdGxlIiwiY2hpbGRyZW4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7O0FBR0EsSUFBTUEsWUFBc0IsR0FBRyxTQUF6QkEsWUFBeUI7QUFBQSxNQUFHQyxRQUFILFFBQUdBLFFBQUg7QUFBQSxzQkFDN0IseUVBQ0UsNkJBQUMsZUFBRDtBQUFRLElBQUEsTUFBTTtBQUFkLGtCQUNFLDZCQUFDLGdCQUFEO0FBQVMsSUFBQSxTQUFTLEVBQUMsZUFBbkI7QUFBbUMsSUFBQSxXQUFXLEVBQUMsVUFBL0M7QUFBMEQsSUFBQSxRQUFRO0FBQWxFLElBREYsQ0FERixlQUlFLDZCQUFDLFlBQUQ7QUFBSyxJQUFBLEVBQUUsRUFBQztBQUFSLGtCQUNFLDZCQUFDLG1CQUFEO0FBQVksSUFBQSxPQUFPLEVBQUM7QUFBcEIsS0FBMEJBLFFBQTFCLENBREYsQ0FKRixDQUQ2QjtBQUFBLENBQS9COztlQVdlRCxZIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEhpZGRlbiwgQm94LCBEaXZpZGVyLCBUeXBvZ3JhcGh5IH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUnO1xuXG5jb25zdCBQcm9kdWN0VGl0bGU6IFJlYWN0LkZDID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8PlxuICAgIDxIaWRkZW4gc21Eb3duPlxuICAgICAgPERpdmlkZXIgY2xhc3NOYW1lPVwidGl0bGUtZGl2aWRlclwiIG9yaWVudGF0aW9uPVwidmVydGljYWxcIiBmbGV4SXRlbSAvPlxuICAgIDwvSGlkZGVuPlxuICAgIDxCb3ggbXI9XCJhdXRvXCI+XG4gICAgICA8VHlwb2dyYXBoeSB2YXJpYW50PVwiaDVcIj57Y2hpbGRyZW59PC9UeXBvZ3JhcGh5PlxuICAgIDwvQm94PlxuICA8Lz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFByb2R1Y3RUaXRsZTtcbiJdfQ==